import { Component, OnInit} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global";
import { HttpParams } from "@angular/common/http";
import * as CONSTANT from "../../../services/constants"
import swal from "sweetalert2";
import { ToastrService } from "ngx-toastr";
import { UserDetailsService } from "src/app/services/user/user-details.service";
@Component({
  selector: "app-inventory-history",
  templateUrl: "./inventory-history.component.html",
  styleUrls: ["./inventory-history.component.css"]
})
export class InventoryHistoryComponent implements OnInit {

  allData:any = [];
  inventoryData:any;
  subscriptionData:any;
  progress:any;
  subscriptionStats:any;
  public userDatas: any;
  public userPermissionData: any;
  constructor(public route: ActivatedRoute, private router: Router,private api: AdminService,private toastrService: ToastrService,private userDetailsService: UserDetailsService) { 
    
    this.userDetailsService.getRecruiterUserData();
    this.userDetailsService.userDetailsObserver.subscribe(userData => {
      this.userDatas = userData; 
    });
    this.userDetailsService.getRecruiterPermission();
    this.userDetailsService.userPermissionObserver.subscribe(res => {
      this.userPermissionData = res; 
    }); }

  ngOnInit(): void {
    this.getSubscription();
    this.getInventory();
  }

  getSubscription(){
    let params = new HttpParams(); 
    this.api.getData(apiUrl._getActiveSubscription,params)
    .subscribe(async (res) => { 
      this.subscriptionStats = res.data.userData
      this.subscriptionData = res.data.subscribePayment
      this.getPercent() 
    })
  }
  getInventory(){
    let params = new HttpParams(); 
    this.api.getData(apiUrl._inventoryHistory,params)
    .subscribe(async (res) => { 
      this.inventoryData = res.data.inventoryPayment 
      // this.getPercent() 
    })
  }

  getPercent(){
    this.subscriptionData.map((dateExp)=>{
      var countDownDate = new Date(dateExp.expirydate).getTime();
      var startDate = new Date(dateExp.createdAt).getTime();
      var now = new Date().getTime();
      var distanceWhole = countDownDate - startDate;
      var distanceLeft = countDownDate - now;
      var minutesLeft = Math.floor(distanceLeft / (1000 * 60));
      var minutesTotal = Math.floor(distanceWhole / (1000 * 60));
      this.progress = Math.floor(((minutesTotal - minutesLeft) / minutesTotal) * 100);
      dateExp['progresBar']=this.progress
    })
  }
  cancelSubscription(subData){
    let subscribePayment;
    subscribePayment=subData.id
    let text= "<p>Are you sure you want to Cancel this subscription?</p>";
    swal.fire({
      html: text,
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText:"Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      width: 500
    }).then((result) => {
      if (result.isConfirmed) { 
        const data={
          subscriptionId: subscribePayment
        }
        this.api.postData(apiUrl._cancelSubscription,data)
        .subscribe(async (res) => {
          this.getSubscription();
          this.userDetailsService.getRecruiterUserData();
          // this.toastrService.success("", message)
        })
      }   else{
        result.dismiss === swal.DismissReason.cancel
      }    
    });
  }
  subscriptionOnOff(subscriptionData){ 
    console.log(subscriptionData);
    
    let subscribePayment;
    let message;
    let text;
    if(subscriptionData.isPause == 2){
      subscribePayment=2
      message="Auto Renewal successfully switched on."
      text = "<p>Are you sure you want to switch on recurring payments?</p>";
    } else{
      subscribePayment=1
      message="Auto Renewal successfully switched off."
      text = "<p>Are you sure you want to switch off recurring payments?</p>";
    } 
    swal.fire({
      html: text,
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText:"Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      width: 500
    }).then((result) => {
      if (result.isConfirmed) { 
        const data={
          subscriptionId : subscriptionData.id,
          status : subscribePayment
        }
        this.api.putData(apiUrl._pauseAndResumePayment,data)
        .subscribe(async (res) => {
          this.getSubscription();
          this.userDetailsService.getRecruiterUserData();
          this.toastrService.success("", message)
        })
      }   else{
        result.dismiss === swal.DismissReason.cancel
      }    
    });
  }
  inventoryOnOff(inventoryData){ 
    let inventoryPayment;
    let message;
    let text;
    if(inventoryData == 0){
      inventoryPayment=1
      message=" Auto Renewal On successfully!"
      text = "<p>Are you sure you want to On Recurring Payment?</p>";
    } else{
      inventoryPayment=0
      message="Auto Renewal Off successfully!"
      text = "<p>Are you sure you want to Off Recurring Payment?</p>";
    }
     
    swal.fire({
      html: text,
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText:"Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      width: 500
    }).then((result) => {
      if (result.isConfirmed) { 
        const data={
          inventoryPayment : inventoryPayment
        }
        this.api.putData(apiUrl._recurringPayment,data)
        .subscribe(async (res) => {
          this.getInventory();
          this.userDetailsService.getRecruiterUserData();
          this.toastrService.success("", message)
        })
      }   else{
        result.dismiss === swal.DismissReason.cancel
      }    
    });
  }
}
